import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT, AUTH_EXPIRY } from '../actions/auth'
import { USER_REQUEST } from '../actions/user'
import axios from 'axios'
import router from '../../router'
import jwtDecode from 'jwt-decode'
import moment from 'moment'
// import { Bugfender } from '@bugfender/sdk'

const state = { token: localStorage.getItem('user-token') || '', status: '', hasLoadedOnce: false, tokenExp: null, tokenExpiry: false }

const getters = {
  isAuthenticated: state => !!state.token, // how does this works on refresh, but state.token dont
  authStatus: state => state.status,
  getToken: state => localStorage.getItem('user-token')
}

const actions = {
  [AUTH_REQUEST]: ({ commit, dispatch }, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      // curl -i -H "Content-Type: application/json" -X POST -d '{ "userName": "admin", "password": "password" }' http://localhost:8080/microservices/login

      axios({ url: process.env.VUE_APP_REST_SERVICES_PATH + 'login', data: user, method: 'POST' })
        .then(resp => {
          const token = resp.headers.authorization.replace('Bearer ', '')// resp.data.token
          dispatch(AUTH_SUCCESS, token)
          resolve(token)
        })
        .catch(err => {
          commit(AUTH_ERROR, err)
          localStorage.removeItem('user-token')
          delete axios.defaults.headers.common.Authorization
          reject(err)
        })
    })
  },
  [AUTH_SUCCESS]: ({ commit, dispatch }, token) => {
    // removing temporal/session information
    localStorage.removeItem('sales-list-dataTable')

    localStorage.setItem('user-token', token) // store the token in localstorage
    // const userId = jwtDecode(token).pid
    axios.defaults.headers.common.Authorization = 'Bearer ' + token
    var expiryDate = jwtDecode(token).exp ? moment(moment.unix(jwtDecode(token).exp)) : null
    // console.log('expiryDate: ' + expiryDate)
    let logoutTimeout = null
    let expiryAlertTimeout = null
    if (expiryDate) {
      const milisNotify = 300000 // 5 minutes
      const now = moment()
      const milisToexpire = expiryDate.diff(now)
      // console.log('expiration: ' + expiryDate.format('DD/MM/YYYY  H:mm:ss') + ' -- milis to expire: ' + milisToexpire)
      logoutTimeout = setTimeout(() => {
        if (getters.isAuthenticated) {
          dispatch(AUTH_LOGOUT).then(() => { router.push('/login') })
        }
      }, milisToexpire)
      expiryAlertTimeout = setTimeout(() => {
        commit(AUTH_EXPIRY)
        // console.log('Warning, token is about to expire')
      }, milisToexpire - milisNotify)
    }
    commit(AUTH_SUCCESS, { token: token, tokenExp: expiryDate, logoutTimeout: logoutTimeout, expiryAlertTimeout: expiryAlertTimeout })
    dispatch(USER_REQUEST)
  },
  [AUTH_LOGOUT]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      if (state.logoutTimeout) clearTimeout(state.logoutTimeout)
      if (state.expiryAlertTimeout) clearTimeout(state.expiryAlertTimeout)

      commit(AUTH_LOGOUT)
      delete axios.defaults.headers.common.Authorization
      // console.log('AUTH_LOGOUT commited!')
      // axios.interceptors.request.eject(0)
      localStorage.removeItem('user-token')
      localStorage.setItem('logout', Date.now())
      // Bugfender.removeDeviceKey('user') Se deja siempre el último como registro en Bugfender
      resolve()
    })
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
    state.token = ''
    state.tokenExp = null
    state.tokenExpiry = false
  },
  [AUTH_SUCCESS]: (state, payload) => {
    state.status = 'login'
    state.token = payload.token
    state.tokenExp = payload.tokenExp
    state.hasLoadedOnce = true
    state.tokenExpiry = false
    state.logoutTimeout = payload.logoutTimeout
    state.expiryAlertTimeout = payload.expiryAlertTimeout
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error'
    state.token = ''
    state.tokenExp = null
    state.hasLoadedOnce = true
    state.tokenExpiry = false
  },
  [AUTH_LOGOUT]: (state) => {
    state.status = 'logout'
    state.token = ''
    state.tokenExp = null
    state.tokenExpiry = false
    state.logoutTimeout = null
    state.expiryAlertTimeout = null
  },
  [AUTH_EXPIRY]: (state) => {
    state.tokenExpiry = true
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
